// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","FooterContainer":"Footer_FooterContainer__1E6KN","FooterMenu":"Footer_FooterMenu__2cM0k"};